export default __webpack_public_path__ + "static/media/device-status.63ceda15.svg";